<template>
    <div>
        <div class="pass_container" v-if="show_password">
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md8>
                        <v-card >
                            <v-toolbar dark color="teofly-login-header">
                                <v-toolbar-title>Enter password to access</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-form ref="form" v-model="valid" lazy-validation>
                                    <v-text-field
                                        prepend-icon="lock"
                                        name="password"
                                        label="Password"
                                        type="password"
                                        v-model="password"
                                        :rules="passwordRules"
                                        required
                                    ></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="orange-button"
                                    @click="onSubmit"
                                    :loading="loading"
                                    :disabled="!valid || loading"
                                >View Project</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>

            </v-container>
        </div>
        <NavBar v-if="loadingLayersList" shared="true" noleft="true" />
        <LayerView v-if="loadingLayersList" :project_id="project_id" />
    </div>
</template>

<script>

import NavBar       from "../NavBar";
import LayerView    from "../PSComponents/LayerView";

export default {
    name: "ProjectView",
    props: ['project_id'],
    data () {
        return {
            show_password: true,
            password: '',
            valid: false,
            loading: false,
            loadingLayersList: false,
            items: [],
            passwordRules: [
                v => !!v || 'Password is required'
            ]
        }
    },
    computed:{
        shared_layers () {
            return this.$store.getters.shared_layers;
        }
    },
    methods: {
        onSubmit (){
            if (this.$refs.form.validate()){
                this.$store.dispatch('getSharedLayers', {slugid: this.project_id, password: this.password})
                .then(() => {
                    if (this.shared_layers.length != 0){
                        let cnt = 0;
                        for (let layer in this.shared_layers){
                            if (this.shared_layers[layer].count_panorama_files != 0){
                                this.items.push({name: this.shared_layers[layer].name, id: this.shared_layers[layer].id, layer});
                            }
                            else{
                                delete(this.shared_layers[layer]);
                            }
                        }
                        if (this.items.length == 0) this.$router.push('/no_data');
                        else{
                            this.$store.dispatch('setSharedNotEmpty', this.items);
                            this.show_password = false;
                            this.loadingLayersList = true;
                        }
                    }
                    else{
                        this.$router.push('/no_data');
                    }
                })
                .catch(() => {});
            }
        }
    },
    components:{
        NavBar,
        LayerView
    },
    created() {
        this.$vuetify.theme.dark = true;
    }
};
</script>
